import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';
import { Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import CobroServicios from '../../Catalogos/clientes/precios/cobroServicios';

class EspecialUrrea extends FormComponent {
  initialData = true;

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: '', saveUrl: '', backUrl: '' },
      new Form([
        Form.Field('autocomplete', 'guia_cliente_clave', 'Cliente', '', [Validators.required], 12),
        Form.Field('select', 'g_id_origen', 'Origen', '', [Validators.required], 6),
        Form.Field('date', 'g_fecha', 'Fecha', '', [Validators.required], 6),
        Form.Field('autocomplete', 'guia_remitente_clave', 'Remitente', '', [Validators.required], 12),
        // Form.Field('file', 'guias_file', 'guias', '', [Validators.required], 6),
      ], [], ''), this.formData
    )
    this.setState({ 
      serviciosIncluidos: [{
        id_lista_precio_tipo: 2,
        id_valor_aplicado: 1,
      },
      {
        id_lista_precio_tipo: 3,
        id_valor_aplicado: 1,
      }
    ],
    paquetes: [{
      gp_cantidad: 1,
      gp_id_embalaje: '17',
      gp_precio: '',
      gp_tipo_cobro: '',
      }]
    })
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;
    if (this.formCliClve) {
      params["cli_rs"] = this.formCliClve;
      this.formCliClve = null;
    }
    if (this.formCliId) {
      params["cli_id"] = this.formCliId;
    }
    if (this.formRemClve) {
      params["rem_clve"] = this.formRemClve;
      this.formRemClve = null;
    }
    if (this.initialData) {
      params["initial_data"] = true;
      this.initialData = false;
    }
    const Res = await Http.get(`guia/documentacion-urrea/form?${objectAsParams(params)}`);
    if (!Res.error) {
      const { clientes, remitentes, ods, tiposDeCobro, embalajes, embalajes_grupos, defaultData } = Res.data;
      let { id_cliente } = this.state;
      let id_remitente = false;
      newForm = Form.FieldOptions(newForm, 'g_id_origen', ods, 'id', 'label');
      if (clientes) {
        newForm = Form.FieldOptions(newForm, 'guia_cliente_clave', clientes, 'id', 'cliente_rsocial');
      }
      if (remitentes) {
        newForm = Form.FieldOptions(newForm, 'guia_remitente_clave', remitentes, 'id', 'cliente_rems');
      }
      if (defaultData) {
        const { cliente, origen, remitente } = defaultData;
        newForm = Form.FieldOptions(newForm, 'guia_cliente_clave', [cliente], 'id', 'cliente_rsocial');
        newForm = Form.FieldOptions(newForm, 'guia_remitente_clave', [remitente], 'id', 'cliente_rems');
        id_cliente = cliente.id;
        id_remitente = remitente.id;
        newForm = Form.Patch(newForm, {
          guia_cliente_clave: cliente.id,
          g_id_origen: origen.id,
          guia_remitente_clave: remitente.id
        })
        this.formCliId = id_cliente;
      }
      this.setState({
        tiposCobro: tiposDeCobro,
        embalajes,
        embalajes_grupos,
        id_cliente: id_cliente,
        id_remitente,
      });
    }
    newForm = Form.ValueChange(newForm, {
      guia_cliente_clave: async (field) => { this.clienteChange(field, 'formCliClve') },
      guia_remitente_clave: async (field) => { this.remitenteChange(field, 'formRemClve') },

    });
    return newForm;
  }

  agregarPaquete = () => {
    const { paquetes = [] } = this.state;
    paquetes.push({
      gp_cantidad: '',
      gp_id_embalaje: '',
      gp_descripcion: '',
      gp_peso: '',
      gp_precio: '',
      gp_tipo_cobro: '',
    });
    this.setState({ paquetes })
  }

  paqueteChange = (i, prop, value) => {
    let { paquetes } = this.state;
    paquetes[i][prop] = value;
    // g_peso_real = paquetes.map(paq => paq.gp_peso).reduce((paq, current) => Number(paq) + Number(current));
    // g_piezas = paquetes.map(paq => paq.gp_cantidad).reduce((paq, current) => Number(paq) + Number(current));
    this.setState({ paquetes });
  }

  paqueteDelete = (indexPaquete) => {
    let { paquetes } = this.state;
    paquetes = paquetes.filter((p, i) => (i !== indexPaquete));
    this.setState({ paquetes })
  }

  clienteChange = async (field, variable) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`cliente/one/${field.Value}`);
      if (!Res.error) {
        const { id } = Res.data;
        this.formCliId = Res.data.id;
        this.setState({ id_cliente: id });
      }
    } else {
      this[variable] = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }

  remitenteChange = async (field, variable) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`cliente-remitente/one/${field.Value}`);
      if (!Res.error) {
        const { id } = Res.data;
        this.formRemId = id;
        this.setState({ id_remitente: id })
      }
    } else {
      this[variable] = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }

  handleOnUserSelectService = (listaPrecios) => {
    let { serviciosIncluidos } = this.state;
    serviciosIncluidos = listaPrecios.especificaciones;
    this.setState({ serviciosIncluidos });
  }

  onSubmit = async () => {
    let { FormData: form,  id_cliente, id_remitente, serviciosIncluidos, paquetes, origen } = this.state;
    this.setState({ loading: true });
    // const file = form.Fields.find(field => field.Name === 'guias_file').Value;
    origen = form.Fields.find(field => field.Name === 'g_id_origen').Value;
    const fecha = form.Fields.find(field => field.Name === 'g_fecha').Value;

    let formSend = new FormData();
    formSend.append('type', 6);
    // formSend.append('file', file[0]);
    formSend.append('id_cliente', id_cliente);
    formSend.append('id_remitente', id_remitente);
    formSend.append('servicios_incluidos', JSON.stringify(serviciosIncluidos));
    formSend.append('origen', origen);
    formSend.append('fecha', fecha);
    formSend.append('id_remitentev', id_remitente);
    formSend.append('gp_id_embalaje', paquetes[0].gp_id_embalaje);
    formSend.append('gp_descripcion', paquetes[0].gp_descripcion);
    try {
      const Resp = await Http.post('guia-especial/guias', formSend);
      if (!Resp.error) {
        const { guias } = Resp.data;
        let mensaje = `${guias}`
        this.setState({ loading: false, sbOpen: true, sbMsg: mensaje });
      } else {
        this.setState({ loading: false, sbOpen: true, sbMsg: Resp.errMsg });
      } 
    } catch (error) {
      this.setState({ loading: false, sbOpen: true, sbMsg: `Error: ${error}` });
    }
  }

  render() {
    const { paquetes = [], tiposCobro = [], serviciosIncluidos = [], loading , embalajes = [] } = this.state;
    return (
      <div>
        <this.FormRender />
        <div className="guia-detalles">
          <div style={{ textAlign: "left", paddingTop: 10, paddingBottom: 10 }}>
            <h3>Embalaje</h3>
          </div>
          {paquetes.map((paquete, index) => (
            <div className="row paquete-row" key={`paquete-row-${index}`} style={{ minWidth: 'auto' }}> 
              <div className="col-sm-6">
                <FormControl variant="outlined" className="form-field">
                  <InputLabel>Embalaje</InputLabel>
                  <Select
                    value={paquete["gp_id_embalaje"]}
                    onChange={e => {
                      this.paqueteChange(
                        index,
                        "gp_id_embalaje",
                        e.target.value
                      );
                    }}
                  >
                    {embalajes.map((embalaje, i) => (
                      <MenuItem value={embalaje.id} key={i}>
                        {embalaje.embalaje}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-sm-6">
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    value={paquete["gp_descripcion"]}
                    onChange={e => {
                      this.paqueteChange(
                        index,
                        "gp_descripcion",
                        e.target.value
                      );
                    }}
                    type="number"
                    label="Descripción"
                    multiline
                    fullWidth
                    rows="1"
                    variant="outlined"
                  />
                </FormControl>
              </div>
            </div>
          ))}
          {paquetes.length < 1 && (
            <span style={{ textAlign: "center" }}>NO HAY PAQUETES</span>
          )}
        </div>
        <div className='row' >
        <div className="col-sm-8">
          <CobroServicios
            // disabled={disabled ? disabled : false}
            disableRecoleccion
            disableFlete
            disableCpac
            title={"Servicios Incluidos en la Guía"}
            inverse
            fillValue
            // tipoServicios={{ g_autoservicio, g_almacenaje, g_completo }}
            handleOnCobroServicios={this.handleOnUserSelectService}
            tiposListas={tiposCobro}
            listaPreciosServicios={{ especificaciones: serviciosIncluidos }}
          />
          </div>
        <div className="col-sm-4">
          <Button
            variant='contained' 
            disabled={loading}
            color='primary'
            onClick={() => this.onSubmit()}
            >
              <div 
                style={{ marginRight: 10, padding: 0, height: 22 }} 
                hidden={!loading}>
                <CircularProgress color="secondary" size={20} />
              </div>
              Cargar Guias
          </Button>
        </div>
        </div>
      </div>
    )
  }
}

export default withRouter(EspecialUrrea)
